import * as api from '../api';
import {isLogged, getCustomerGuid} from "../customer";
import {formatDate, formatNumber, renderItems, getCdnImageUrl} from "../functions";
import {Modal} from "../mySubscription/modal";




// https://551922.myshoptet.com/objednavka/dekujeme/
if ($('[data-testid="notifierMessage"]').text().indexOf('nebyla nalezena') > -1 && shoptet.cookie.get('subscription') || (window.location.href.indexOf('subscription=1') > -1)) {
	if(window.location.href.indexOf('subscription=1') > -1) {
		$('[data-testid="notifierMessage"]').text('Děkujeme vaše předplatné bylo úspěšně vytvořeno');
	} else {
		$('[data-testid="notifierMessage"]').text('Děkujeme vaše předplatné bylo úspěšně autorizováno');
	}


	if ($('body').hasClass('in-kosik')) {

		var tableRow = function (item, data) {
			var subId = data.id;
			return `<tr class="single-merchandise">
                                    <td class="single-merchandise-info row">
                                       <div class="single-merchandise-foto large-2 medium-3 small-0 columns left">
                                          <a href="${item.url}" title="${item.name}">
                                          <img src="${getCdnImageUrl(`/user/shop/related/${item.image}`)}">
                                          </a>
                                       </div>
                                       <div class="single-merchandise-text-info large-10 medium-9 small-12 columns">
                                          <span class="text-wrapper" data-testid="cartProductName">
                                             <a href="${item.url}" class="main-link">${item.name}</a>
                                          </span>
                                       </div>
                                       <div class="clear">&nbsp;</div>
                                    </td>
                                   
                                    <td class="tac">
                                         
                                          <div>
                                           ${item.quantity + " Ks"}
                                       </div>
                                    </td>
                                    <td class="tac">
                                          ${item.discount} %
                                    </td>
                                    <td class="tac mobile-hide" data-testid="cartItemPrice">
                                       ${formatNumber(item.priceWithDiscount)} Kč
                                    </td>
                                    <td class="tac">
                                       <strong class="nowrap" data-testid="cartPrice">${formatNumber(item.priceWithDiscount*item.quantity)} Kč/obj</strong>
                                    </td>
                                    
                                    <td class="tac my-subscription">
                                   
</td>
                                    
                                 </tr>`
		}

		var childrenTable = function (data) {

			var table = [];
			data.children.forEach(function (child) {
				var items = [];
				child.items.forEach(function (item) {
					items.push(tableRow(item, data));
				})

				table.push(`<table class="child" style="${(data.status === 'CANCELLED') ? 'opacity: 0.5; margin-bottom: 10px' : 'margin-bottom: 10px'}">
                              <colgroup>
                                 <col style="width: 45%">
                                 <col class="mobile-hide" style="width: 9%">
                                 <col style="width: 7%">
                                 <col class="mobile-hide" style="width: 12%">
                                 <col style="width: 10%">
                                 <col style="width: 5%">
                                
                              </colgroup>
                              <thead>
                                 <tr>
                                    <th class="tal">
                                       ${child.childName}  (${data.period.text})
                                    </th>
                                    <th class="tac">
                                       Množství
                                    </th>
                                    
                                    <th class="tac mobile-hide">
                                       Sleva
                                    </th>
                                    <th class="tac mobile-hide">
                                       Cena za kus
                                    </th>
                                    <th class="tac">
                                       Součet
                                    </th>
                                    
                                    <th class="tac"></th>
                                   
                                 </tr>
                              </thead>
                              <tbody>
                                ${items.join('')}
                              </tbody>
                           </table>`)

			})

			return table.join('');
		}

		var renderDetail = function(data) {

			var dateTable = '';

			var children = [];
			data.children.forEach(function (child) {
				children.push(child.childName);
			})

			data.calendar.forEach(function (date, i) {
				/* <td style="display: none">${data.code}</td>
									<td style="display: none">${children.length === 0 ? 'Nemáte žádné dítě v předplatném' : children.join(', ')}</td>
									<td style="display: none">${data.period.text}</td>
									*/
				dateTable += `
							<tr>
								<th style="padding: 5px 0">${formatDate(date.regularDate)}</th>
								
								<td>${data.code}</td>
								<td>${children.join(', ')}</td>
								<td>${data.period.text}</td>
							
							</tr>
							</tr>`;
			})


			return `<div class="my-subscription">
			<div class="address">
				<div class="address-item">
					<h3>Fakturační údaje</h3>
					
					<p>
						<strong>${data.firstname} ${data.lastname}</strong><br /> 
						Email: ${data.email}<br />
						Telefon: ${data.phoneNumber}<br />
						${data.address.street} ${data.address.houseNumber} <br/>
						${data.address.zipCode} ${data.address.city}<br />
						${data.address.country}
					</p>
					</div>
					<div class="address-item">
					<h3>Doručovací údaje</h3>
					
					${data.shippingAddress ? `<p>
						<strong>${data.shippingAddress.fullName}</strong><br /> 
						${data.shippingAddress.street} ${data.shippingAddress.houseNumber} <br/>
						${data.shippingAddress.zipCode} ${data.shippingAddress.city}<br />
						${data.shippingAddress.country}
					</p>` : `<p>Totožná s fakturační</p>`}
					
					</div>
				</div>
				
				<div id="cart-wrapper">
				
					<div id="cart">
					${childrenTable(data)}
					</div>
					
					<div class="sub-footer">
					<p>Cena celkem včetně DPH: <strong>${formatNumber(data.totalPrice)} Kč/obj</strong></p>
					
				</div>
				</div>
			
				
			${data.status === 'ACTIVE' ? `
				<h2><span class="subscription-calendar-title">Přehled následujících odeslání tohoto předplatného</span></h2>
				<table style="margin-bottom: 30px" class="subscription-calendar child">
					<thead>
						<tr>
							<th>Datum</th>
							<th>Kód</th>
							<th>Děti v předplatném</th>
							<th>Perioda odesílání</th>
						</tr>
					</thead>
					<tbody id="date-content">
						${dateTable}
					</tbody>
				</table>
` : ''}
				
				
				
				
		</div>`;
		};

		var content = '<div id="loading-content-sub">Načítám...</div>';
		if (getCustomerGuid()) {
			api.patchData(
				'cart-finish',
				{},
				{ guid: getCustomerGuid() }
			).done(function (data) {
				$('body').addClass('in-my-subscription');

				var html = renderDetail(data);
				html += '<style>.mehub-bonus-checkout-container {display: none!important;}</style>';

				$('#loading-content-sub').html(html);
			});
			//content = '';
		} else {
			content = '<p>Detaily o vašem předplatném najdete po přihlášení do svého účtu v sekci <strong>"Moje předplatné"</strong>.<br />Zde si předplatné můžete i spravovat.</p>';
		}


		$('#content-in').html(`<h1>${window.location.href.indexOf('subscription=1') === -1 ? 'Děkujeme vám za autorizaci předplatného' : 'Děkujeme vám. Předplatné bylo úspěšně vytvořeno.'}</h1>${content}`);
	}
}


var render = function (quantity, items, totalPrice) {
	if(dataLayer[0].shoptet.currency !== 'CZK') return '';

	var rows = renderItems(items);
	var view = '';

	//if(quantity > 0) {
		view = `<div id="subscription-recapitulation" class="cart-recapitulation menu-element-submenu align-right">
                    
                    <div id="sub-items">${rows}</div>
                    
                            <div class="cart-reca-single darken bigger-text">
                    <span class="header-cart-recap-summary-text">
                        Cena celkem                    </span>
                    <strong id="sub-total-price">${formatNumber(totalPrice)} Kč</strong>
                </div>
            
          
                <div class="cart-reca-single tar vat-info">
                                            <em>Ceny jsou uvedeny včetně DPH</em>
                                    </div>
            

            
                <div class="cart-reca-single last tar">
                    <a href="/predplatne/" class="button tiny success" rel="nofollow" data-testid="nextStep">Pokračovat v objednávce</a>
                </div>
            

            </div>`;
	//}

	return $('#header-cart-wrapper').after(`<div id="subscription-cart-wrapper" class="${quantity === 0 ? 'hide' : ''} header-cart-wrapper menu-element-wrap">
			    <a href="/predplatne/" id="subscription-cart" class="header-cart" data-testid="headerCart" rel="nofollow">
			    <strong class="header-cart-count" data-testid="headerCartCount">
			        <span>${quantity}</span>
			    </strong>
			        <strong class="header-cart-price">
			         Předplatné
			        </strong>
			    </a>
			    ${view}
			</div>`);
}

var headerCart = function () {
	if ($('body').find('#subscription-cart-wrapper').length === 0) {
		if (isLogged()) {
			api.getData('get-mini-cart', {guid: getCustomerGuid()})
				.done(function (data) {
					render(data.totalQuantity, data.data, data.totalPrice)
				})
		} else {
			render(0, [], 0);
		}


		$(document).on('submit', '.mini-cart-sub-delete', function (e) {
			e.preventDefault()
			showSpinner();
			api.deleteData('delete-cart-item', {
				itemId: $(this).find('.item-id').val(),
				guid: getCustomerGuid(),
			}).done(function () {
				api.getData('get-mini-cart', {guid: getCustomerGuid()})
					.done(function (data) {
						$('#subscription-cart-wrapper .header-cart-count span').text(data.totalQuantity);
						$('#subscription-recapitulation #sub-items').html(renderItems(data.data));
						$('#subscription-recapitulation #sub-total-price').html(formatNumber(data.totalPrice) + " kč");
						if(data.totalQuantity <= 0) {
							$('#subscription-cart-wrapper').addClass('hide');
						}
						hideSpinner();
					})
			})
		})

	}
}
var list = document.getElementsByClassName("place-cart-here")[0];
if (list !== undefined) {
	const observer = new MutationObserver(function () {
		headerCart();
	});
	observer.observe(list, {childList: true});
}

